<template>
  <div id="mk-admin-uploaded-docs-table">
    <!-- uploaded docs table -->
    <h3 class="hr-title mb-3">Uploaded Documents</h3>

    <div class="mb-3">
      <div
        class="amb-vue-table amb-whitebg-vue-table amb-documents-table table-hover-rows"
        ref="selectedUploadedDocumentsTable"
      >
        <div class="row ml-3 mt-3 mb-2 mr-3 pt-3 px-3 pb-0">
          <div class="col-5">
            <h4>File</h4>
          </div>
          <div class="col-3">
            <h4>Type</h4>
          </div>
          <div class="col-2">
            <h4>Status</h4>
          </div>
          <div class="col-2">
            <h4>Actions</h4>
          </div>
        </div>

        <draggable
          id="admin-uploaded-documents"
          class="table-area-draggable"
          :list="uploadedDocuments"
          @change="addToUploadedDocuments"
          :options="{group:'conditioning'}"
          :disabled="isRefAppSubmitted"
        >
          <div
            class="row mx-3 mb-3 p-3 table-row has-move"
            v-for="row in uploadedDocuments"
            :key="row.id"
            @click="rowClick(row)"
          >
            <input
              type="file"
              v-show="false"
              v-if="!row.is_app_document"
              :ref="`upload_field_${row.id}`"
              @change="uploadFileLine($event, row)"
              :disabled="isRefAppSubmitted"
            />
            <!-- filename -->
            <div slot="filename" class="col-5 d-flex flex-column">
              <p class="my-0">
                <strong v-if="!row.uploaded">Upload Pending</strong>
                <strong v-else><span v-if="row.is_app_completed" style="color: red;">* </span>{{row.filename}}</strong>
                <button
                  class="amb-icon-btn ml-2"
                  type="button"
                  v-if="row.uploaded && !isRefAppSubmitted"
                  @click.stop="renameFilename(row)"
                >
                  <i class="fas fa-pen"></i>
                </button>
              </p>
              <p
                class="mb-0 pt-2 text-grey"
              >{{row.uploader_name}}, {{row.created_at + "Z" | moment("DD-MM-YYYY, hh:mm") }}</p>
            </div>

            <!-- type -->
            <div slot="uploader_name" class="col-3 d-flex">
              <select
                v-if="!row.is_app_document"
                class="w-100"
                v-model="row.document_type_id"
                @click.stop
                @change="changeFileType(row)"
                :disabled="isRefAppSubmitted"
              >
                <option
                  v-for="docType in docTypes"
                  :key="docType.id"
                  :value="docType.id"
                >{{docType.name}}</option>
              </select>
            </div>

            <!-- status select -->
            <div slot="status" class="col-2">
              <div @click.stop>
                <select v-model="row.status" @change="changeDocStatus(row)" class="ml-auto w-100" :disabled="isRefAppSubmitted">
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </div>

            <!-- actions column -->
            <div class="col-2 d-flex" slot="actions">
              <div @click.stop>
                <button
                  class="amb-icon-btn mr-2"
                  type="button"
                  v-if="row.uploaded"
                  @click="viewDocument(row)"
                >
                  <i class="fas fa-eye"></i>
                </button>

                <button
                  class="amb-icon-btn mr-2"
                  type="button"
                  v-if="row.pdf_versions.length"
                  @click="showPdfVersion(row)"
                >
                  <i class="fas fa-file-alt"></i>
                </button>

                <button
                  v-if="!isRefAppSubmitted"
                  class="amb-icon-btn mr-2" type="button" @click="deleteDocument(row)">
                  <i class="fas fa-trash-alt" style="color: #ee4123;"></i>
                </button>

                <!-- <select v-model="row.doc_category" @change="changeDocCategory(row)" class="ml-auto">
                  <option value="null">Uploaded</option>
                  <option value="internal">Internal</option>
                  <option value="bank">Bank</option>
                </select>-->
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: ["selectedDocs", "documentsOptionsTable", "documents", "docTypes"],
  data() {
    return {
      isRefAppSubmitted: false
    };
  },
  mounted() {
    this.isRefAppSubmitted = this.$store.getters["referrer/appSubmitted"];
  },
  methods: {
    renameFilename(row) {
      this.$emit("renameFilename", row);
    },
    addToUploadedDocuments(value) {
      if (value.added) {
        value.added.element.doc_category = "backend";
        this.$emit("changeDocCategory", value.added.element);
      }
    },
    rowClick(data) {
      if (data.uploaded) {
        this.viewDocument(data);
      } else {
        if (!data.is_app_document) {
          let el = this.$refs["upload_field_" + data.id][0];
          el.click();
        }
      }
    },
    showPdfVersion(data) {
      this.viewDocument(data.pdf_versions[0]);
    },
    uploadFileLine(e, doc) {
      let file = e.target.files[0];
      this.$emit("uploadFile", { file: file, id: doc.id });
    },
    changeFileType(doc) {
      this.$emit("changeFileType", doc);
    },
    changeDocCategory(doc) {
      this.$emit("changeDocCategory", doc);
    },
    changeDocStatus(doc) {
      this.$emit("changeDocCategory", doc);
    },
    viewDocument(doc) {
      this.$emit("viewDocument", doc);
    },
    deleteDocument(doc) {
      this.$emit("deleteDocument", doc);
    },
    // migrate this (might not worth it)
    gotoDocumentGenerator() {
      this.$router.push({
        name: "Document Generator",
        params: { docs: this.selectedDocs }
      });
    }
  },
  computed: {
    uploadedDocuments() {
      return this.documents.filter(
        doc => doc.doc_category === "backend" && (!doc.document_type || !doc.document_type.document_type) && !doc.parent_document_id
      );
    }
  }
};
</script>

<style scoped>
.table-row {
  background-color: #f9f9f9;
  border-radius: 10px;
  /* min-height:80px; */
  cursor: pointer;
  transition: 0.2s all ease-in-out;
}

.table-area-draggable {
  min-height: 80px;
}

.table-row:hover {
  background-color: #284da5;
  color: #fff;
}

.table-row:hover p {
  color: #fff;
}
</style>

